<template>
  <div>
    
    <el-form-item v-for="(items, itemIdex) in oss.dropListInfo" :key="itemIdex" :label="items.DisplayNMCN" :prop="items.DisplayNMCN">
      <el-select @blur="sendMsg()" v-model="items.ControlValue" clearable placeholder="请选择">
        <el-option v-for="item in items.dropData" :key="item.Name" :label="item.Name" :value="item.ID">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item @blur="sendMsg()" v-for="witems in oss.textBoxInfo" :key="witems.key1" :label="witems.DisplayNMCN" :prop="witems.DisplayNMCN">
      <el-input v-model="witems.ControlValue"></el-input>
    </el-form-item>

  </div>
</template>
<script>
export default {
  props: {
    fData: {

    }
  },
  data() {
    return {
      value: '',
      oss: []
    }
  },
  methods: {
    sendMsg() {
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
      this.$emit('func', this.oss);
    },
    RefushData(fData) {
      this.oss.dropListInfo[0].ControlValue = fData.Bak1;
      this.oss.dropListInfo[1].ControlValue = fData.Bak2;
      this.oss.textBoxInfo[0].ControlValue = fData.Bak16;
      this.oss.textBoxInfo[1].ControlValue = fData.Bak17;
    }
  },
  mounted() {
    this.oss = JSON.parse(sessionStorage.getItem('UserGetMenuButton'))[0].listInfo;
  },
}
</script>

<style scoped>

</style>